export enum ButtonColor {
    primary = 'primary',
    secondary = 'secondary',
    white = 'white',
}
